import { render } from "./CollectionCardIncubator.vue?vue&type=template&id=132b1144"
import script from "./CollectionCardIncubator.vue?vue&type=script&lang=js"
export * from "./CollectionCardIncubator.vue?vue&type=script&lang=js"

import "./CollectionCardIncubator.vue?vue&type=style&index=0&id=132b1144&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__